module.exports = __webpack_public_path__ + "img/eth.d4d67525.png";